
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#22577A] to-[#38a3a5] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-white rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-40 h-40 border border-white rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-20 h-20 border border-white rounded-full"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full text-white font-medium mb-6">
          <i className="ri-rocket-line mr-2"></i>
          Ready to Transform Your Marketing?
        </div>
        
        <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-6">
          Start Your AI Marketing
          <span className="block">Journey Today</span>
        </h2>

        <p className="text-base sm:text-lg md:text-xl text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto">
          Join thousands of marketers who have revolutionized their social media strategy with our AI-powered platform. Get started with a free trial today.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a href="/signup" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#22577A] rounded-lg font-semibold text-base sm:text-lg shadow-xl hover:shadow-2xl hover:scale-105 transition-all cursor-pointer">
              <i className="ri-play-circle-line"></i>
              Start Free Trial
            </button>
          </a>
          <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-lg font-semibold text-base sm:text-lg hover:bg-white hover:text-[#22577A] hover:scale-105 transition-all cursor-pointer">
            <i className="ri-calendar-line"></i>
            Schedule Demo
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
              <i className="ri-time-line text-2xl"></i>
            </div>
            <h3 className="font-semibold mb-2">Quick Setup</h3>
            <p className="text-white/80 text-sm">Get started in under 5 minutes</p>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-2xl"></i>
            </div>
            <h3 className="font-semibold mb-2">Secure & Reliable</h3>
            <p className="text-white/80 text-sm">Enterprise-grade security</p>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
              <i className="ri-customer-service-line text-2xl"></i>
            </div>
            <h3 className="font-semibold mb-2">24/7 Support</h3>
            <p className="text-white/80 text-sm">Expert help when you need it</p>
          </div>
        </div>
      </div>
    </section>
  );
}
